// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2zkSU","signatureBlock":"Footer_signatureBlock__Q4EBB","signature":"Footer_signature__leVfg"};